import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {CheckoutComponent} from "../../../pages/checkout/checkout.component";
import {CartService} from "../../../service/cart";
import {ApiService} from "../../../service/api";
import {StateService} from "../../../service/state";

@Component({
    selector: 'checkout-overview',
    templateUrl: './overview.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {

    @Input('checkout')
    public checkout: CheckoutComponent;

    @Input('payment')
    public payment: any;

    @Input('address')
    public address: any;

    public pickups: any = {
        seiersberg: '8055 Seiersberg',
        merkendorf: '8344 Merkendorf'
    }

    constructor(public stateService: StateService,
                public apiService: ApiService,
                public cart: CartService) {
    }

    ngOnInit() {
    }

    public setMessage(event): void {
        this.checkout.message = event.target.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/checkout/overview/overview.component.ts